<script>
import {
    layoutMethods
} from "@/state/helpers";
import simplebar from "simplebar-vue";

/**
 * Right sidebar component
 */
export default {
    components: {
        simplebar,
    },
    data() {
        return {
            config: {
                handler: this.handleRightBarClick,
                middleware: this.middleware,
                events: ["click"],
            },
            layout: this.$store ? this.$store.state.layout.layoutType : {} || {},
            width: this.$store ? this.$store.state.layout.layoutWidth : {} || {},
            topbar: this.$store ? this.$store.state.layout.topbar : {} || {},
            sidebarType: this.$store ?
                this.$store.state.layout.leftSidebarType :
                {} || {},
            loader: this.$store ? this.$store.state.layout.loader : {} || {},
        };
    },
    methods: {
        ...layoutMethods,
        hide() {
            this.$parent.toggleRightSidebar();
        },
        // eslint-disable-next-line no-unused-vars
        handleRightBarClick(e, el) {
            this.$parent.hideRightSidebar();
        },
        // eslint-disable-next-line no-unused-vars
        middleware(event, el) {
            if(event.target.classList)
            return !event.target.classList.contains("toggle-right");
        },
        changeLayout(layout) {
            this.changeLayoutType({
                layoutType: layout,
            });
        },
        changeType(type) {
            return this.changeLeftSidebarType({
                leftSidebarType: type,
            });
        },
        changeWidth(width) {
            return this.changeLayoutWidth({
                layoutWidth: width,
            });
        },
        changeTopbartype(value) {
            return this.changeTopbar({
                topbar: value,
            });
        },
        changeloader() {
            return this.changeLoaderValue({
                loader: this.loader,
            });
        },
    },
};
</script>

<template>
<div>
    <div v-click-outside="config" class="right-bar">
        <simplebar class="h-100">
            <div class="rightbar-title px-3 py-4">
                <h5 class="m-0">Definições</h5>
            </div>

            <div class="p-3">
                <h6 class="mb-0">Menu</h6>
                <hr class="mt-1" />
                <b-form-radio-group v-model="layout" stacked @input="changeLayout($event)">
                   <b-form-radio value="vertical" class="mb-1">Vertical</b-form-radio>
                  <b-form-radio v-show="false" value="horizontal" class="mb-1">Horizontal</b-form-radio>
               </b-form-radio-group>
               <!-- Width -->

                <!--
                <h6 class="mt-3">Largura</h6>
                <hr class="mt-1" />
                <b-form-radio-group v-model="width" stacked @input="changeWidth($event)">
                    <b-form-radio value="fluid" class="mb-1">Fluid</b-form-radio>
                    <b-form-radio value="boxed" class="mb-1">Boxed</b-form-radio>
                </b-form-radio-group>
                -->
                <!-- Sidebar -->
                <div v-if="layout === 'vertical'">
                    <h6 class="mt-3">Cor do menu</h6>
                    <hr class="mt-1" />
                    <b-form-radio-group v-model="sidebarType" stacked @input="changeType($event)">
                        <b-form-radio value="dark" class="mb-1">Escuro</b-form-radio>
                        <b-form-radio value="light" class="mb-1">Claro</b-form-radio>
                        <b-form-radio value="colored">Azul</b-form-radio>
                        <b-form-radio value="icon" class="mb-1">Icon</b-form-radio>
                    </b-form-radio-group>
                </div>

                <!-- Topbar -->
                <div v-if="layout === 'horizontal'">
                    <h6 class="mt-3">Cor do menu</h6>
                    <hr class="mt-1" />
                    <b-form-radio-group v-model="topbar" stacked @input="changeTopbartype($event)">
                        <b-form-radio value="dark" class="mb-1">Dark</b-form-radio>
                        <b-form-radio value="light" class="mb-1">Light</b-form-radio>
                        <b-form-radio value="colored" class="mb-1">Colored</b-form-radio>
                    </b-form-radio-group>
                </div>
            </div>

        </simplebar>
    </div>

    <!-- Right bar overlay-->
    <div class="rightbar-overlay"></div>
</div>
</template>

<style lang="scss"></style>
